import { createApp } from 'vue'
import App from './App.vue'
import emitter from './utils/eventbus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import md5 from 'js-md5'
import router from './router/router'

const app = createApp(App)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.config.globalProperties.emitter = emitter
app.config.globalProperties.md5 = md5

router.isReady().then(() => {
    app.mount('#app')
})
